import React  from 'react';

export function Loader(props){
    if(!props.show) return null;
    return(
        <div className="loader" id="loader-4"><span></span><span></span><span></span></div>
    )
}